import { render, staticRenderFns } from "./BlockBanner.vue?vue&type=template&id=24d16080&scoped=true&"
import script from "./BlockBanner.vue?vue&type=script&lang=js&"
export * from "./BlockBanner.vue?vue&type=script&lang=js&"
import style0 from "./BlockBanner.vue?vue&type=style&index=0&id=24d16080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d16080",
  null
  
)

export default component.exports